import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/descuentos';
import Modal from "./Modal";

class Descuentos extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
        };
        this.toggle 			= this.toggle.bind(this);

    }

   toggle(evt, prospectoid = null, title = "Agregar Tipo de cliente")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }

    componentDidMount() {

        this.props.get();
    }

    render() {

        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Descuentos Contpaq</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                            <ReactTable
                                getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.id, 'Editar Descuentos')
                                        } 
                                  
                                    }
                                }}
                              data      = {this.props.descuentos.data}
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Tipo Cliente', accessor: 'nombre', maxWidth: 250},
                                {Header: 'DM Paquete', accessor: 'dm_paquete' ,maxWidth: 120},
                                {Header: 'DM Actualizacion', accessor: 'dm_actualizacion', maxWidth: 120},
                                {Header: 'DM Cambio Carcts.', accessor: 'dm_caracteristica' , maxWidth: 120},
                                {Header: 'DD Paquete', accessor: 'dd_paquete' , maxWidth: 120},
                                {Header: 'DD Actualizacion', accessor: 'dd_actualizacion', maxWidth: 120},
                                {Header: 'DD Cambio Carcts.', accessor: 'dd_caracteristica' , maxWidth: 120},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth : 80,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.id, 'Editar Descuentos')}>
                                                    <IconEdit />
                                                </Button>{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={(filter, row) => {
                                var patt = new RegExp(filter.value, "i");
                                return row[filter.id].search(patt) > -1 || row[filter.id].search(patt) > -1;
                              }}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                 <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                />

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        descuentos: state.descuentos,
    }
};

export default connect(mapStateToProps, actions)(Descuentos)


// WEBPACK FOOTER //
// ./src/views/descuentoscontpaq/index.js